import React, { type ReactElement } from 'react'
import * as Sentry from '@sentry/nextjs'
interface JsonListProps {
  jsonString: string | undefined
}
//This function renders the properties in a single line...BC
export function JsonPropertyLine ({ jsonString }: JsonListProps): ReactElement | null {
  if (!jsonString) {
    return (<span>No Filters</span>)
  }

  let obj: Record<string, any>

  try {
    obj = JSON.parse(jsonString)
  } catch (error) {
    Sentry.captureMessage(`Invalid JSON string: ${jsonString} `)
    return null
  }

  return (
    <div>
      {Object.keys(obj).length === 0
        ? (
          <p>No Filters</p>
          )
        : (
          <>
            {Object.keys(obj).map((key) => (
              <span className="pr-2" key={key}>
                <strong>{key}:</strong> {obj[key]}
              </span>
            ))}
          </>
          )}
    </div>
  )
}
